import type { AnnotationType } from '@/core/annotationTypes'

export const ELLIPSE_ANNOTATION_TYPE: AnnotationType = 'ellipse'
